<template>
    <div :class="{ 'dark-theme': darkTheme }">
        <div class='map' ref='google-map'></div>
    </div>
</template>
<script>
import gmapstyle from '@/config/gmapstyle';
import gmapstyleDarkTheme from '@/config/gmapstyle_dark_theme';

export default {
    name: 'google-map',

    props: {
        markers: {
            type: [Array, Object],
            default() {
                return [] || {};
            }
        },

        darkTheme: {
            type: Boolean,
            default: false,
        },

        zoom: {
            type: Number,
            default: 1.4,
        },
    },

    data() {
        return {
            map: null,
            infowindow: null,
        }
    },

    mounted() {
        this.initMap();
        this.resizeMap();

        window.addEventListener('resize', this.resizeMap);
    },

    methods: {
        initMap() {
            let mapElement = this.$refs['google-map'];

            this.map = new google.maps.Map(mapElement, {
                center: { lat: 0, lng: 0 },
                zoom: this.zoom,
                styles: (this.darkTheme) ? gmapstyleDarkTheme : gmapstyle,
                disableDefaultUI: true,
                panControl : false,
                backgroundColor: 'none'
                // gestureHandling: 'none',
            });

            this.infowindow = new google.maps.InfoWindow({
                content: '',
                pixelOffset: new google.maps.Size(0, 160)
            });

            this.renderMarkers();
        },

        renderMarkers() {
            if (this.markers.length) {
                let bounds = new google.maps.LatLngBounds();
                let marker = {};
                this.markers.forEach((markerData, index) => {
                    let latLng = {
                        lat: markerData.latitude * 1,
                        lng: markerData.longitude * 1
                    }
                    marker = this.placeMarker(latLng, this.map, markerData);
                    bounds.extend(marker.position);
                    if ($(document).width() > 990 && index == 0) {
                        this.createInfoWindow(marker, markerData);
                        marker.setIcon(require('@/assets/img/select.png'));
                    }
                });

                // this.map.fitBounds(bounds);

                // if (this.markers.length === 1) {
                //     setTimeout(() => {
                //         this.map.setZoom(1.4);
                //     }, 500);
                // }

                if (this.$route.name == 'CityList') {
                    this.map.setCenter(new google.maps.LatLng(45, 0))
                }
            } else {
                let latLng = {
                    lat: this.markers.latitude * 1,
                    lng: this.markers.longitude * 1,
                };
                this.placeMarker(latLng, this.map, this.markers);
                this.map.setCenter(latLng);
            }
        },

        placeMarker(position, map, markerData) {
            let marker = new google.maps.Marker({
                position: position,
                map: map,
                title: markerData.name,
                icon: require('@/assets/img/dot.png')
            });

            marker.addListener('click', () => {
                this.createInfoWindow(marker, markerData);
                marker.setIcon(require('@/assets/img/select.png'));
            });

            marker.addListener('mouseover', () => {
                this.createInfoWindow(marker, markerData);
                marker.setIcon(require('@/assets/img/select.png'));
            });

            this.infowindow.addListener('anchor_changed', () => {
                marker.setIcon(require('@/assets/img/dot.png'));
            });

            this.infowindow.addListener('closeclick', () => {
                marker.setIcon(require('@/assets/img/dot.png'));
            });

            return marker;
        },

        createInfoWindow(marker, markerData) {
            var content = '<div id="iw-container"><div class="iw-title">'+ markerData.name + '</div><div class="iw-subtitle"><i class="icons8-user-account"></i>'+ markerData.membercount.toLocaleString() + ' ' + this.pluralize('member', markerData.membercount) + '</div></div>';
            this.infowindow.setContent(content);
            this.infowindow.open(this.map, marker);
        },

        resizeMap() {
            if($(document).width() < 991) {
                this.map.setZoom(0.7);
            } else {
                this.map.setZoom(this.zoom);
            }

            google.maps.event.trigger(this.map, 'resize');
        },

        pluralize(word, amount, plural) {
            let singularText = word;
            let pluralText = (plural) ? plural: `${word}s`;
            return (amount > 1 || amount == 0) ? pluralText : singularText;
        }
    },
  }
</script>

<style lang="scss" scoped>
.dark-theme .map {
    position: absolute;
    left: 0;
    margin: 0;
    @include media-breakpoint-up(md) {
        position: relative;
        margin-right: 0;
        margin-left: auto;
        height: 339px;
    }

    @include media-breakpoint-up(lg) {
        width: 650px;
        height: 465px;
    }

    @include media-breakpoint-up(xl) {
        width: 680px;
        height: 465px;
    }
}

.map {
    width: 100%;
    height: 266px;
    background-color: $secondary;
}
</style>

<style>
.gm-style .gm-style-iw-c {
    background-color: var(--cs-primary-base);
    box-shadow: 0px 14px 16px #00000029;
    border-radius: 3px;
    padding: 0;
}

.gm-style .gm-style-iw-t::after {
    background: var(--cs-primary-base);
    top: -115px;
    box-shadow: none;
}

@media (max-width: 991px) {
    .gm-style .gm-style-iw-c {
        top: -42px;
    }
}

@media (max-width: 767.98px) {
    .gm-style .gm-style-iw-c {
        top: -53px;
    }
    .gm-style .gm-style-iw-t::after {
        top: -122px;
        transform: translate(-50%,-50%) rotate(132deg);
    }
}

.gm-style .gm-style-iw-d {
    overflow: auto !important;
    padding: 5px;
    color: #ffffff;
}

@media (min-width: 768px) {
    .gm-style .gm-style-iw-d {
        padding: 10px;
    }
}

@media (min-width: 992px) {
    .gm-style .gm-style-iw-d {
        padding: 30px;
    }
}

#iw-container {
    width: 125px;
    height: 60px;
    text-align: center;
}
/* @media (min-width: 992px) {
    #iw-container {
        width: 184px;
        height: 55px;
    }
} */

@media (min-width: 768px) {
    #iw-container {
        width: 164px;
        height: 55px;
        text-align: center;
    }
}

@media (min-width: 992px) {
    #iw-container {
        width: 200px;
        height: 55px;
        text-align: center;
    }
}

.iw-title {
    font-size: 15px;
    color: #ffffff;
    font-weight: 700;
    margin-bottom: 6px;
}

@media (min-width: 992px) {
    .iw-title {
        font-size: 18px;
    }
}

.iw-subtitle {
    font-size: 14px;
    color: #ffffff;
    font-weight: 400;
}

@media (min-width: 992px) {
    .iw-subtitle {
        font-size: 16px;
    }
}

#iw-container i {
    vertical-align: middle;
    margin-right: 5px;
    font-size: 18px;
}

.gm-style-iw  button[aria-label="Close"] img {
    width: 20px !important;
    height: 20px !important;
    margin: 13px 0 !important;
}
</style>
